import { defineStore } from 'pinia';

export const useNavbarStore = defineStore({
  id: 'navbar-store',
  state: () => {
    return {
      showNavbar: true,
      showSideBar: false,
      showContact: false,
      showDownloadCta: false,
      scrolled: false,
      showTeamDetail: false,
      carbonBadge: null,
    };
  },
  actions: {
    async fetch () {

    },
    toggleSidebar () {
      this.showSideBar = !this.showSideBar;
    },

    closeSidebar () {
      this.showSideBar = false;
    },

    toggleContact () {
      this.showContact = !this.showContact;
    },

    closeContact () {
      this.showContact = false;
    },

    toggleDownloadCta () {
      this.showDownloadCta = !this.showDownloadCta;
    },

    closeDownloadCta () {
      this.showDownloadCta = false;
    },

    scrolledActive () {
      this.scrolled = true;
    },

    scrolledDisable () {
      this.scrolled = false;
    },

    openTeamDetail () {
      this.showTeamDetail = true;
    },

    closeTeamDetail () {
      this.showTeamDetail = false;
    },

    hideNavbarValue () {
      this.showNavbar = false;
    },

    showNavbarValue () {
      this.showNavbar = true;
    },

    setCarbonBadge (payload) {
      this.carbonBadge = payload;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNavbarStore, import.meta.hot));
}
